require('../upsales/common/components/react/listAccounts.jsx');
require('../upsales/common/components/react/listActivities.jsx');
require('../upsales/common/components/react/listAppointment.jsx');
require('../upsales/common/components/react/table.jsx');
require('../upsales/common/components/react/listSoliditet.jsx');
require('../upsales/common/components/react/listOrders.jsx');
require('../upsales/common/components/react/viewPicker.jsx');
require('../upsales/common/components/react/accountChartSales.jsx');
require('../upsales/common/components/react/accountChartMarket.jsx');
require('../upsales/common/components/react/Loader.jsx');
require('../upsales/common/components/react/flash/root.jsx');
require('../upsales/common/components/react/flash/topList.jsx');
require('../upsales/common/components/react/flash/shield.jsx');
require('../upsales/common/components/react/flash/resultView.jsx');
require('../upsales/common/components/react/flash/clockWidget.jsx');
require('../upsales/common/components/react/voice/root.jsx');
require('../upsales/common/components/react/voice/dialing.jsx');
require('../upsales/common/components/react/voice/inCall.jsx');
require('../upsales/common/components/react/voice/followup.jsx');
require('../upsales/common/components/react/inputs/inputWrappers.jsx');
require('../upsales/common/components/react/inputs/upCountry.jsx');
// Moved out of upsales/ for the React edit-activity modal port (WEB-8899);
// still required here because the Angular modal mounts them through the
// ReactTemplates.editActivity globals they register. root.jsx initialises the
// namespace, so it stays first.
require('../components/EditActivityModal/root.jsx');
require('../components/EditActivityModal/footer.jsx');
require('../components/EditActivityModal/sidebarAccount.jsx');
require('../components/EditActivityModal/sidebarContact.jsx');
require('../components/EditActivityModal/header.jsx');
require('../upsales/common/components/react/alerts/alerts.jsx');
require('../upsales/common/components/react/modals/AddProductCategory.jsx');
